import monetize from './monetize';

export default function (amount, currency) {
    if (typeof amount !== 'number') {
        const amountToNumber = parseFloat(amount);
        if (isNaN(amountToNumber)) {
            return amount;
        }
        amount = amountToNumber;
    }

    return `${currency} ${monetize(amount, currency)}`;
}
